import AOS from 'aos'
import './services.js'
import './resources-grid.js'
import './faqs.js'

window.addEventListener('DOMContentLoaded', () => {
	AOS.init({ duration: 800, once: true, disable: 'mobile', offset: 30 })

	// Navigation stuff
	const header = document.querySelector('header')
	const hamburger = document.querySelector('header .hamburger')
	let previousScrollTop = 0

	window.addEventListener('scroll', e => {
		let currentScrollTop = window.scrollY

		if (currentScrollTop > previousScrollTop && currentScrollTop > 100) {
			header.classList.add('scrolled-down')
		} else {
			header.classList.remove('scrolled-down')
		}

		previousScrollTop = currentScrollTop
	})

	hamburger.addEventListener('click', e => {
		hamburger.classList.toggle('open')
	})

	window.addEventListener('click', e => {
		if (e.target.tagName != 'A' && !e.target.closest('.hamburger')) {
			hamburger.classList.remove('open')
		}
	})

	// Contact form submission popup stuff
	const formStatus = document.querySelector('#contact-form-status')
	const formClose = formStatus?.querySelector('button.close')
	if (formClose && formStatus) {
		formClose.addEventListener('click', e => {
			formStatus.classList.remove('show')
		})
	}
})
